export default __webpack_public_path__ + "static/jetbrains-mono-latin-variable-wghtOnly-normal-88c1288c3e6d46b1647dabaddf24e6b8.woff2";